<div [class.mat-ng-select]="!tableStyle" [class.d-flex]="tableStyle" [class.leave]="usersWithLeave[fc.value]">
    <ng-select
        class="employee-select ng-select-subtext"
        [formControl]="fc"
        [class.ng-select-fill]="!tableStyle"
        [placeholder]="field.name"
        [clearable]="!isRequired"
        [items]="employeesWithLeave"
        bindLabel="name"
        bindValue="id"
        appendTo="body">
        <ng-template ng-option-tmp ng-label-tmp let-item="item">
            <div class="d-flex justify-content-between w-100 gap-2 mt-2" style="line-height: normal">
                <span>{{ item.name }}</span>
                <small class="text-ellipsis">{{ item.function }}</small>
            </div>

            @if (item.leaves?.length) {
                @for (leave of item.leaves; track leave.id) {
                    <div
                        class="d-flex align-items-center w-100 text-muted small gap-2 mt-2"
                        style="line-height: normal">
                        <i class="fa-duotone {{ leave.hourtype | hourtypeIcon }}"></i>
                        <span class="text-ellipsis">{{ leave.hourtype | hourtype }}</span>
                        <span>
                            @if (leave.close_period) {
                                Hele dag
                            } @else {
                                {{ leave.begintime | date: 'H:mm' }}-{{ leave.endtime | date: 'H:mm' }}
                            }
                        </span>
                    </div>
                }
            }
        </ng-template>
    </ng-select>
    <mat-error [control]="fc"></mat-error>
</div>
